import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import cx from "classnames";

export default class CycleButtonBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  highlight = (value) => {
    this.setState({ selected: value});
  }

  render() {
    return (
      <div className={cx("button-box", this.props.classname)}>
        <div className="title">
          <h3>Forecasts</h3>
        </div>
        <div className="buttons">
        {this.props.cycles.map((c,i) => (
                  <Button
                      key={i}
                      label={c}
                      value={c}
                      onEvent={this.props.onEvent}
                      highlight={this.highlight}
                      selected={c === this.state.selected}
                      onClick={1}
                  />
            ))}
      </div>
      </div>
    );
  }
}

CycleButtonBox.propTypes = {
  cycles: PropTypes.array,
}



// WEBPACK FOOTER //
// ./src/CycleButtonBox.js